import React from 'react'
import Logout from '../Logout'
import dashboardHero from '../../assets/images/dashboard-hero.jpg'
const PageHero = ({ pageTitle, pageSubtitle, children }) => {

    return (
        <div className="min-h-72 relative bg-gradient_hero overflow-visible">
            <div
                className="absolute inset-0 bg-cover bg-center opacity-20"
                style={{ backgroundImage: `url(${dashboardHero})` }}
            />
            <div className="relative px-6 py-12">
                <div className="relative max-w-7xl mx-auto">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
                            {pageTitle}
                        </h1>
                        <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
                            {pageSubtitle}
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            {children}
                        </div>
                    </div>
                    <Logout className={"absolute top-0 right-0"} />
                </div>

            </div>
        </div>
    )
}

export default PageHero